module.exports = __webpack_public_path__ + "img/dajiajuhome3.b6face93.png";